import { createRouter, createWebHashHistory  } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/navigation',
    name: 'Navigation',

    component: () => import('../views/Navigation.vue')
  },
  {
    path: '/proNavigation',
    name: 'ProNavigation',

    component: () => import('../views/ProNavigation.vue')
  },
  {
    path: '/markNavigation',
    name: 'MarkNavigation',

    component: () => import('../views/MarkNavigation.vue')
  },
  {
    path: '/login',
    name: 'Login',

    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',

    component: () => import('../views/Register.vue')
  },
  {
    path: '/projects',
    name: 'Projects',

    component: () => import('../views/Projects.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/upload',
    name: 'Upload',

    component: () => import('../views/Upload.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/label',
    name: 'Label',

    component: () => import('../views/Label.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/relation',
    name: 'Relation',

    component: () => import('../views/Relation.vue')
  },
  {
    path: '/project/:project_id(\\d+)/mark/case/firstMark',
    name: 'firstMark',

    component: () => import('../views/firstMark.vue')
  },
  {
    path: '/project/:project_id(\\d+)/mark/case/secondMark',
    name: 'secondMark',

    component: () => import('../views/secondMark.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/settings',
    name: 'Settings',

    component: () => import('../views/Settings.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/download',
    name: 'Download',

    component: () => import('../views/Download.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/dataset',
    name: 'Dataset',

    component: () => import('../views/Dataset.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/dictionary',
    name: 'Dictionary',

    component: () => import('../views/Dictionary.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/Statistics',
    name: 'Statistics',

    component: () => import('../views/Statistics.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/attribute',
    name: 'Attribute',

    component: () => import('../views/Attribute.vue')
  },
  {
    path: '/autologin/:uup',
    name: 'autoLogin',

    component: () => import('../views/Autologin.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/rule',
    name: 'Rule',

    component: () => import('../views/Rule.vue')
  },
  {
    path: '/project/:project_id(\\d+)/premark/preSettings',
    name: 'preSettings',

    component: () => import('../views/preSettings.vue')
  },
  {
    path: '/test',
    name: 'test',

    component: () => import('../views/Test.vue')
  },

]

const router = createRouter({
  mode: 'hash',
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
